import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BookingType } from '@features/booking/calender/model/bookingType';
import { environment } from '@environments/environment';

// Endpoint root
const APIURL = environment.apiUrl;

@Injectable({
  providedIn: 'root',
})
export class BookingTypeService {
  private http = inject(HttpClient);

  getList(): Observable<BookingType[]> {
    return this.http.get<BookingType[]>(`${APIURL}/bookingtypes`);
  }
}
